import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResCategory } from '@/lib/queries/business/v1/types'

import { type ReqDeleteCategoryMutation } from './types'

export const editCategoryMutation = {
  mutationFn: (data: { applicantId: number; categoryName: string }): Promise<ResCategory[]> =>
    w.post({}, `${API_ENDPOINTS.business.v1.case.path.index}/${data.applicantId}/${data.categoryName}`).json(),
}

export const deleteCategoryMutation: MutationOptions<undefined, unknown, ReqDeleteCategoryMutation> = {
  mutationFn: (data) => w.json(data).delete(`${API_ENDPOINTS.business.v1.case.path.index}`).json(),
}
